import { Link } from 'react-router-dom';

export default function Features() {
  const features = [
    {
      icon: 'ri-trophy-line',
      title: 'Competitive Tournaments',
      description: 'Join weekly and monthly Brawlhalla tournaments with cash prizes and ranking points.',
      image: 'https://public.readdy.ai/ai/img_res/e5d8f161246f33a1d7c651ec0e08c922.jpg',
      link: '/tournaments'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Professional Training',
      description: 'Learn from pro players with structured training programs and skill development courses.',
      image: 'https://readdy.ai/api/search-image?query=Gaming%20coach%20teaching%20student%20at%20computer%20setup%2C%20professional%20gaming%20training%20session%20with%20multiple%20monitors%2C%20esports%20coaching%20environment%20with%20gaming%20peripherals%2C%20educational%20gaming%20setup%20with%20purple%20accent%20lighting&width=400&height=300&seq=training-feature&orientation=landscape',
      link: '/training'
    },
    {
      icon: 'ri-video-line',
      title: 'Clip Sharing',
      description: 'Share your best plays, get feedback from the community, and learn from others.',
      image: 'https://readdy.ai/api/search-image?query=Gaming%20content%20creation%20setup%20with%20recording%20equipment%2C%20streaming%20setup%20with%20multiple%20monitors%20showing%20gameplay%20footage%2C%20content%20creator%20workspace%20with%20professional%20lighting%20and%20gaming%20gear%2C%20video%20editing%20station%20for%20gaming%20clips&width=400&height=300&seq=clips-feature&orientation=landscape',
      link: '/clips'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Everything You Need to Excel
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Our platform provides comprehensive tools and resources to help you become a better Brawlhalla player
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Link 
              key={index} 
              to={feature.link}
              className="bg-gray-900 rounded-xl p-8 hover:bg-gray-850 transition-colors cursor-pointer group"
            >
              <div className="mb-6">
                <img 
                  src={feature.image} 
                  alt={feature.title}
                  className="w-full h-48 object-cover object-top rounded-lg group-hover:scale-105 transition-transform"
                />
              </div>
              <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center mb-6 group-hover:bg-purple-700 transition-colors">
                <i className={`${feature.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{feature.title}</h3>
              <p className="text-gray-400 leading-relaxed">{feature.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
